export function createIdempotencyKey(): string {
  return window.crypto.randomUUID();
}
